/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseValidator} from "./BaseValidator";

export class NumericValidator extends BaseValidator {
	constructor() {
		super();
	}

	name(model) {
		return "Must be a number"
	}

	logic(x) {
		return (x != null) ? !isNaN(x) : true;
	}

	message() {
		return "Must be a number";
	}
}